/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Total_LabelInputs */

const en_rental_total_label = /** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const es_rental_total_label = /** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const fr_rental_total_label = /** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const de_rental_total_label = /** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt`)
};

const id_rental_total_label = /** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

/** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */
const ja_rental_total_label = en_rental_total_label;

/** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */
const zh_rental_total_label = en_rental_total_label;

/** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */
const ar_rental_total_label = en_rental_total_label;

/** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */
const it_rental_total_label = en_rental_total_label;

/** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */
const ru_rental_total_label = en_rental_total_label;

/** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */
const pt_rental_total_label = en_rental_total_label;

/** @type {(inputs: Rental_Total_LabelInputs) => LocalizedString} */
const ko_rental_total_label = en_rental_total_label;

/**
* | output |
* | --- |
* | "Total" |
*
* @param {Rental_Total_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_total_label = /** @type {((inputs?: Rental_Total_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Total_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_total_label(inputs)
	if (locale === "es") return es_rental_total_label(inputs)
	if (locale === "fr") return fr_rental_total_label(inputs)
	if (locale === "de") return de_rental_total_label(inputs)
	if (locale === "ja") return ja_rental_total_label(inputs)
	if (locale === "zh") return zh_rental_total_label(inputs)
	if (locale === "ar") return ar_rental_total_label(inputs)
	if (locale === "id") return id_rental_total_label(inputs)
	if (locale === "it") return it_rental_total_label(inputs)
	if (locale === "ru") return ru_rental_total_label(inputs)
	if (locale === "pt") return pt_rental_total_label(inputs)
	return ko_rental_total_label(inputs)
});